import type { CreateOrganizationRequest } from '@/definitions/organization'
import { taxRatePercentToFraction } from '@/utils/taxRateUtils'

import type { CreateOrgFormValues } from '../definitions/createOrganizationForm'

/**
 * Maps the collected form values to the organization create request.
 *
 * The optional fields are omitted rather than sent blank: the columns behind them
 * mean "not set" by being null, so an empty string would record something
 * different from what the user left alone.
 */
export const buildOrganizationRequest = (
  values: CreateOrgFormValues
): CreateOrganizationRequest => {
  const federalTaxId = values.federal_tax_id.trim()
  const taxRate = taxRatePercentToFraction(values.tax_rate)

  return {
    org_name: values.org_name.trim(),
    display_name: values.display_name.trim(),
    ...(federalTaxId && { federal_tax_id: federalTaxId }),
    ...(values.federal_tax_type && { federal_tax_type: values.federal_tax_type }),
    ...(taxRate !== undefined && { tax_rate: taxRate }),
  }
}
